export default {
  data() {
    return {};
  },
  methods: {
    getUsersDNDsWithPaginationFunction: function (
      fromDate,
      toDate,
      userId,
      pageNumber = 1,
      pageSize = 10,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getUserDNDsWithPagination', {
          fromDate,
          toDate,
          userId,
          pageNumber,
          pageSize,
        })
        .then(() => {
          if (this.$store.state.userDNDModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.userDNDModule.userDNDs);
            this.totalPages = Number(this.$store.state.userDNDModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.userDNDModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.userDNDModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.userDNDModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userDNDModule.successFlag) {
                  this.getUsersDNDsWithPaginationFunction(
                    fromDate,
                    toDate,
                    userId,
                    pageNumber,
                    pageSize,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.userDNDModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getUsersDNDsWithPaginationFunction(
                    fromDate,
                    toDate,
                    userId,
                    pageNumber,
                    pageSize,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    enableUserDNDsnFunction: function (type) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('enableUserDND').then(() => {
        if (this.$store.state.userDNDModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$root?.$refs?.Home?.startDNDHome) {
            this.$root.$refs.Home.startDNDHome('home');
          }
          // if (type == 'newCall') {
          //   this.startDNDTime();
          // }
          // if (type == 'home') {
          //   this.startDNDHome('home');
          // }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userDNDModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userDNDModule.successFlag) {
                this.enableUserDNDsnFunction(type);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userDNDModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.enableUserDNDsnFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    disableUserDNDsnFunction: function (type, note) {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        note: note,
      };
      this.$store.dispatch('disableUserDND', data).then(() => {
        if (this.$store.state.userDNDModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (type == 'handle') {
            this.finishDNDTime();
          } else if (type == 'closeNewForm') {
            this.finalizeMissionFuncion();
          } else if (type == 'home') {
            this.finishDNDHome('home');
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userDNDModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userDNDModule.successFlag) {
                this.disableUserDNDsnFunction(type, note);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userDNDModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.disableUserDNDsnFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
  },
};
